<template>
  <div class="bg-white h-screen w-full absolute flex justify-center flex justify-center top-0 left-0 items-center">
    <Loader />
  </div>


</template>

<script>
/* eslint-disable */
    import { bus } from '@/js/Bus'
    import _has from 'lodash/has'
    import store from '@/store'
    import { mapGetters, mapActions } from 'vuex'
import Loader from "./Loader";

    export default {
        name: 'Loading',
      components: {Loader},
      data : function(){

          return  {
              show_chars : false,
              email:null,
              password:null,
              error:{},
              id:null,
              password_field : 'password'
          }
        },

        computed : {
           ...mapGetters({
               accessToken: 'oidc/oidcAccessToken'
           })
        },

        watch : {
            show_chars : function(val){
                    if( val == true ){
                        this.password_field = 'text'
                    }else{
                        this.password_field = 'password'
                    }
            }
        },

        methods : {

            ...mapActions({
                loadFeeAgreement:'client/loadFeeAgreement'
            }),

            login : function(evt){

                evt.preventDefault();

                var vm = this;

                this.$http.post( this.app.version + '/front/login/' + this.id  ,{
                    email : this.email,
                    password : this.password,

                }).then(function(response){

                    vm.$auth.setToken(response.data.token.access_token,response.data.token.expires_in);

                    bus.$emit('authenticated');

                    vm.$store.commit('updateFeeAgreement', response.data.feeAgreement)

                    /** SET local variables here */
                    localStorage.PORTAL_HASH = vm.id
                    localStorage.PORTAL_PROJECT = JSON.stringify(response.data.feeAgreement.project)
                    localStorage.PORTAL_CLIENT = JSON.stringify(response.data.feeAgreement.client)

                    let routeLink = response.data.feeAgreement.hasEligibilities ? '/eligibility' : '/agreement'
                    vm.$router.push(routeLink);

                }).catch(function(error){
                    console.log(error)
                    vm.error = error.response.data;
                });
            }

        },

       created(){
         //get fee agreement data
         let faId = this.$route.params.id;
          let vm = this;
         this.$http.get(`${process.env.VUE_APP_BASE_URL}/${faId}/fee-agreement`)
           .then((response)=>{
              vm.loadFeeAgreement(response.data);
             let routeLink = '';
              if(response.data.status === 'ineligible'){
                routeLink = '/fa/not-eligible';
              }else{
                routeLink = response.data.hasEligibilities ? '/fa/eligibility' : '/fa/agreement'
              }
             vm.$router.push(routeLink);
           })
       }
    }
</script>

<style>
    legend {
        margin-bottom: 0px;
    }
</style>
